import { render, staticRenderFns } from "./LichSuDiemDenForm.vue?vue&type=template&id=80ce49f2"
import script from "./LichSuDiemDenForm.vue?vue&type=script&lang=js"
export * from "./LichSuDiemDenForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports